<script lang="ts" setup>
// @ts-expect-error JS library
import Player from '@vimeo/player'

// @ts-expect-error JS library
import { useMq } from 'vue3-mq'

const props = defineProps<{
  vimeoId: number
}>()

const playerRoot: Ref<HTMLElement | null> = ref(null)
const player: Ref<typeof Player | null> = ref(null)

const { xs, lg } = useMq()

onMounted(() => {
  try {
    if (playerRoot.value && props.vimeoId) {
      player.value = new Player(playerRoot.value, {
        id: props.vimeoId,
        width: xs ? 370 : lg ? 600 : 1000,
      })
    } else {
      console.warn('Player element or id not available')
    }
  } catch (err) {
    console.error(err)
  }
})
</script>

<template lang="pug">
.vimeo-player(ref="playerRoot")
</template>

<style lang="sass" scoped>
.vimeo-player
  @apply w-full relative flex justify-center
  :deep(iframe)
    @apply border-4 border-secondary rounded-lg bg-secondary-o-75
</style>
